import 'rxjs/add/operator/map';
import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { LocalStorageService } from 'ngx-store';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/providers/encryption/encryption.service';

@Component({
  selector: 'app-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['./backup.component.css']
})
export class BackupComponent implements OnInit {
  subscription: Subscription;
  memory: any = {};
  name = "chat now";
  position = "float-left";
  positionFromUser;
  messages = [];
  msgVal: string = "";
  itemsRef;
  itemsRefBackup;
  items = [];
  itemsBackup = [];
  username;
  itemsRefIMGBp;
  itemsImageLists = [];
  verify;
  height = [];
  width = [];
  constructor(
    private afd: AngularFireDatabase,
    private ls: LocalStorageService,
    private router: Router,
    public encryption: EncryptionService
  ) {
    this.itemsRefBackup = afd.list("pschatsBackup");
    this.itemsBackup = this.itemsRefBackup.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
    this.itemsRefIMGBp = afd.list("psimagetestBackup");
    this.itemsImageLists = this.itemsRefIMGBp.snapshotChanges().map(changes => {
      console.log(changes);
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
    this.itemsRefIMGBp.valueChanges()
      .subscribe(courses => {
        console.log("courses", courses); // Check the returned values;
        this.itemsImageLists = courses;
        if (this.itemsImageLists) {
          for (let i = 0; i < this.itemsImageLists.length; i++) {
            this.height[i] = 250;
            this.width[i] = 250;
          }
        }
      })
  }

  ngOnInit() {
  }

  addItem() {
    const data = (<HTMLInputElement>document.getElementById("val")).value;
    if (data) {
      this.itemsRefBackup.push({
        title: data,
        username: this.username
      });
      (<HTMLInputElement>document.getElementById("val")).value = "";
    }
  }

  deleteItem(key: string) {
    this.itemsRef.remove(key);
  }

  deleteEverything() {
    this.itemsRefBackup.remove();
  }

  deleteIMG() {
    this.itemsRefIMGBp.remove();
  }

  code() {
    const data = (<HTMLInputElement>document.getElementById("code")).value;
    if (data == "8000") {
      this.verify = true;
    } else {
      this.verify = false;
    }
    (<HTMLInputElement>document.getElementById("code")).value = "";
  }


  zoomIn(i) {
    this.width[i] = this.width[i] + 3;
    this.height[i] = this.height[i] + 3;
  }

  zoomOut(i) {
    this.width[i] = this.width[i] - 3;
    this.height[i] = this.height[i] - 3;
  }

}
